import * as R from 'ramda'
import { safePropEq } from 'libs/ramdaExt'
import { formatHomelessGroup } from 'commons/groupLogic'

export const SUBSCRIBER_WITHOUT_GROUP = 1137
export const groupWithSubscriberType = {
  NORMAL: 0,
  EVERYONE: 1,
  HOME_LESS_GROUP: 2, //SUBSCRIBER_WITHOUT_GROUP
}

export const groupTypeEquals = safePropEq('type')
export const getGroupType = R.prop('type')

const filteroutEveryoneAndGroup = R.filter(
  R.complement(
    R.anyPass([
      groupTypeEquals(groupWithSubscriberType.EVERYONE),
      groupTypeEquals(groupWithSubscriberType.HOME_LESS_GROUP),
    ]),
  ),
)

const subscriberWithoutGroup = R.compose(
  R.head,
  R.filter(groupTypeEquals(groupWithSubscriberType.HOME_LESS_GROUP)),
)
export const getEverySubgroupId = R.compose(
  R.path(['tags', 0, 'id']),
  R.find(groupTypeEquals(groupWithSubscriberType.EVERYONE)),
  R.prop('groups'),
)

//move the subscriberWithoutGroup to the top
export const adjustList = R.curry((formatMessage, list) => {
  const headGroup = subscriberWithoutGroup(list)
  if (R.isNil(headGroup)) return filteroutEveryoneAndGroup(list)
  else
    return R.prepend(
      formatHomelessGroup(formatMessage, headGroup),
      filteroutEveryoneAndGroup(list),
    )
})
